import React, { Component } from 'react';
import './Contact.css';


export default class Contact extends Component {


    render() {
        return (<div className="container">
            <div>
                <h1> Contact </h1>
            </div>
            <div>
                <div className="social_block">
                    <span><i class="fa fa-twitter" aria-hidden="true"></i></span>
                    <span><a href="https://twitter.com/senthilmpro" target="_blank" rel="noopener noreferrer"> Twitter</a></span>

                </div>
                <div className="social_block">
                    <span>
                        <i class="fa fa-github" aria-hidden="true"></i>
                    </span> 
                    <span>
                        <a href="https://github.com/senthilmpro" target="_blank" rel="noopener noreferrer"> Github</a>
                    </span>

                </div>
                <div className="social_block">
                    <span>
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                    </span> 
                    <span>
                        <a href="https://www.linkedin.com/in/senthilmpro/" target="_blank" rel="noopener noreferrer"> Linkedin</a>
                    </span>

                </div>
            </div>
        </div>)
    }

}